export const SCROLL_SOFT_SKILLS = [
  "PROACTIVITY",
  "POSITIVE ATTITUDE",
  "QUICK THINKING",
  "PROBLEM SOLVING",
  "ASSERTIVENESS",
  "CURIOSITY",
]
